import { Fragment, useState, useEffect } from "react";
import { withTranslation } from "next-i18next";
import { useCurrentUser } from "@hooks/use-current-user";
import Link from "@components/core/Link";

const CatalogBreadcrumb = ({ breadcrumbs, t }) => {
  const user = useCurrentUser();

  const [breadcrumbsLinks, setBreadcrumbsLinks] = useState([]);

  const displayLinkHref = (linkHref) => {
    return `/${linkHref}`;
  };

  function displayLinks() {
    if (!breadcrumbs || breadcrumbs?.length === 0) return [];

    return breadcrumbs.reduce(
      (accumulator, { id, title, slug }) => {
        accumulator.paths.push(slug);
        const linkHref = accumulator.paths.join("/");
        accumulator.links.push(
          <Fragment key={id}>
            <Link
              href={displayLinkHref(linkHref)}
              className="link-dark font-weight-normal"
              noUnderline
              data-testid={`catalog-breadcrumb-${slug}`}
            >
              /&nbsp;
              {title}
              &nbsp;
            </Link>
          </Fragment>,
        );

        return accumulator;
      },
      {
        links: [],
        paths: [],
      },
    );
  }

  useEffect(() => {
    setBreadcrumbsLinks(displayLinks());
  }, [breadcrumbs]);

  if (breadcrumbs.length === 0) return null;

  return (
    <div className="d-flex flex-wrap justify-content-center font-size-sm mb-1">
      <Link
        href={user ? "/home" : "/"}
        passHref
        className="link-dark font-weight-normal"
        noUnderline
      >
        {t("common:home_page")}
        &nbsp;
      </Link>
      {breadcrumbsLinks.links}
    </div>
  );
};

export default withTranslation("common")(CatalogBreadcrumb);
